

export default {
    props: {
        childComp: {
                type: Boolean,
                default: false
        }
    },
    data() {
        return {            
            open: false,
            errorRecord: {} //keep track of error states of child comps
        }
    },
    watch: {
        hasErrors(v) {
            this.$store.commit('survey/CHANGE_FOCUS_ERROR_STATE', v)
        }
    },
    computed: {
        hasErrors() {
            let hasE = false
            for (const errState in this.errorRecord) {
                if (this.errorRecord.hasOwnProperty(errState)) {
                   if (this.errorRecord[errState]) hasE = true
                }
            }
            return hasE
        },
        windowWidth () { return this.$store.state.windowWidth }
    },
    created() {

        if (this.$store.state.survey.currentFocusIndex === this.compIndex) {
            this.openClose()
        }

    },
    methods: {        
        view() {            
            if (this.windowWidth < 992) {
                document.getElementById("surveypreview").scrollIntoView({ block: 'end',  behavior: 'smooth' })                
            } 
            
            this.$emit('requestview', this.compIndex)

        },
        remove() {
            this.$emit('remove', this.compIndex)
        },
        moveUp(){
            this.$emit('moveUp', this.compIndex)
        },
        moveDown() {
            this.$emit('moveDown', this.compIndex)
        },
        handleErrors({fieldAddress,hasErrors}) {                     
                        
            const propName = 'e' + JSON.stringify(fieldAddress).replace(/[^\w\s]/gi, '')            
            
            /*const oldRecord = JSON.parse(this.errorRecordJSON)

            const newObject = {}
            newObject[propName] = hasErrors

            const newRecord = {...oldRecord, ...newObject}

            //this.errorRecordJSON = JSON.stringify(newRecord)*/

            this.$set(this.errorRecord, propName, hasErrors)

        },        
        openClose() {
            
            //check if allowed to open or close                        

            if (!this.open) {
                this.$store.commit(
                    "survey/CHANGE_FOCUS_INDEX",
                    this.compIndex
                )
            } else {

                if (this.hasErrors) {
                    this.$vs.notify({
                        title: 'Finish editing',
                        text: 'There are errors inside the step you\'re currently editing. You\'ll need to fix those before you can close the step.',
                        color: 'warning',
                        time: 32500,
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                        return
                } else {
                    this.$store.commit(
                        "survey/CHANGE_FOCUS_INDEX",
                        false
                    )
                }                
            }
            this.open = !this.open     
                    
        },
        save() {                
            //saved
            this.openClose()
        },       
    }
}



function checkStepValidity(step) {

    //apart from welcome, there should be question text
    if (step.type !== 'welcome') {        
        if (step.content.ask) {
            if (!step.content.ask.trim()) {
                return 'This step needs to have at least a main question.'
            }
        } else {
            return 'This step needs to have at least a main question.'
        }
    }

    //if its share, there should be actions
    if (step.type === 'shareq') {
        if (step.shareActions.length === 0) return 'This share/review step needs at least one active share/review platform.'
    }
    
    //if its multi or single, there should be more than one options
    if (step.type === 'multiq' || step.type === 'singleq') {
        if (step.answerOptions.length < 2) return 'This step needs at least 2 options that a respondent can pick from.'

        let optionsWithData = 0
        step.answerOptions.forEach(aO => {
            if (aO.text.trim() !== '') optionsWithData++
        });

        if (optionsWithData < 2) {
            return 'Each option must have text describing it.'
        }

    }

    return false

}